import React from 'react';

interface Props {
  title: string;
  icon: React.ReactNode;
  color: string;
  className?: string;
}

function Banner({ title, icon, color, className }: Props) {
  return (
    <div
      className={`p-4 border border-${color}-200 bg-${color}-50 rounded-md shadow-sm ${className}`}
    >
      <div className="flex items-center">
        {icon}
        <p className={`text-${color}-700 font-medium text-lg`}>{title}</p>
      </div>
    </div>
  );
}

export default Banner;
